export default "__VITE_ASSET__CDIax8A___"